<div class="main container" *ngIf="executed">
  <div *ngIf="loading$ | async" class="spinner-backdrop">
	  <div class="spinner-container">
	    <div class="spinner-box">
	      <i class="fas fa-spinner fa-spin fa-fw fa-2x"></i> 
	      <div class="spinner-text">{{ message$ | async }}</div>
	    </div>
	  </div>
  </div>
  <div class="accent-color text-center page-header">
    <h1><i class="fa fa-check fa-2x" aria-hidden="true"></i></h1>
    <h1>Thank You!</h1>
  </div>

  <div *ngIf="!isKiosk">
    <h3>Order # {{ newPurchase?.uuid }}</h3>
    <p>Your checkout is complete. You may now download your order or continue shopping.</p>

    <div class="panel panel-default">
      <div class="panel-heading text-center">
        <label><u>Order Summary</u></label>
      </div>
      <div class="panel-body">
        <table class="table table-condensed">
          <thead>
            <tr>
              <td>Item</td>
              <td class="text-right">Item Price</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let page of pageList">
              <td>{{ page.title }}</td>
              <td class="text-right">{{ page.amount | currency:'USD' }}</td>
              <td class="text-right">
                <button class="btn btn-md btn-primary" style="margin-right:5px;margin-bottom:5px" (click)="download(page.download)">Download</button>
                <button class="btn btn-md btn-primary" style="margin-bottom:5px" (click)="download(page.downloadPDF)">Download as PDF</button>
              </td>
            </tr>
          </tbody>
        </table>
        <hr>
        <div class="text-right">
          <button style="margin-right:5px;margin-bottom:5px" class="btn btn-info btn-md" (click)="print()">Print Order Summary</button>
          <button style="margin-right:5px;margin-bottom:5px" class="btn btn-info btn-md" (click)="downloadOrder(newPurchase.uuid, false)">Download Order</button>
          <button style="margin-bottom:5px" class="btn btn-info btn-md" (click)="downloadOrder(newPurchase.uuid, true)">Download Order as PDF</button>
        </div>
      </div>
    </div>

    <div class="well" *ngIf="!user?.loggedin" style="margin-top:10px">
      <div class="row">
        <div class="col-sm-5 col-sm-offset-1 text-center">
          <i class="fa fa-5x fa-envelope-o text-red" aria-hidden="true"></i>
          <h3>Please provide an email address</h3>
          <p>By providing an email address, you will have the ability to redownload this order in the future.</p>
        </div>
        <div class="col-sm-4 col-sm-offset-1">
          <form>
            <label for="inputEmail">Email:</label>
            <input type="email" [(ngModel)]="input.email" name="email" class="form-control" required>
            <label for="inputEmail2">Confirm Email:</label>
            <input type="email" [(ngModel)]="input.email2" name="email2" class="form-control" required>
            <br>
            <button type="button" class="btn btn-primary btn-md" [disabled]="emailSent" (click)="emailLink()">Send Email</button>
            <i *ngIf="emailSent" class="fa fa-3x fa-check-circle-o accent-color"></i>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isKiosk" class="print-slip">
    <h2>Please take this information to the front desk</h2>
    <h3>Kiosk: {{ user?.firstName || user?.username }}</h3>
    <h3>Date and Time: {{ newPurchase?.creation }}</h3>
    <button class="btn btn-warning btn-md pull-right" (click)="endSession()">End Session</button>
  </div>
</div>

<div class="main container text-center full-center" *ngIf="executed === false">
  <h1><span class="glyphicon glyphicon-remove-sign text-red"></span></h1>
  <h3>Invalid checkout</h3>
</div>
